<template>
  <div>
    <b-card class="shadow">
      <div class="row animate__animated animate__fadeIn">
        <div class="col-md-12">
          <div class="d-flex">
            <div class="mr-auto">
              <h3 class="mb-3 text-gray-800">
                {{ $t("Registro de participações em atividades do SCFV") }}
              </h3>
            </div>
            <div class="text-gray-800">
              <a
                class="router-link-exact-active active"
                @click="
                  $router.push('/dashboard/relatorios/atividades/inscritos')
                "
              >
                Relatório de Atividades do SCFV
              </a>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="input-group mb-3">
            <b-input
              :placeholder="$t('Buscar por nome')"
              class="form-control search-input"
              type="text"
              v-model="search"
              v-on:change="getItens(null)"
              aria-describedby="input-search"
            />
            <div class="input-group-append" role="button">
              <span class="input-group-text" id="input-search"
                ><i class="fas fa-search search-icon"
              /></span>
            </div>
          </div>
        </div>
        <div class="col-12">
          <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
          />
          <b-table
            :fields="[
              {
                key: 'id',
                label: $t('Usuários'),
              },
              {
                key: 'participacoes_confirmadas',
                label: $t('Participações Confirmadas'),
                class: 'text-center',
              },
              {
                key: 'participacoes_nao_confirmadas',
                label: $t('Participações Não Confirmadas'),
                class: 'text-center',
              },
            ]"
            :items="itemList"
            :responsive="true"
            striped
            hover
            show-empty
            small
            outlined
            stacked="md"
            table-class="mb-3"
          >
            <template v-slot:cell(id)="data">
              Usuário:
              <strong
                >{{
                  data.item.nome_social
                    ? data.item.nome_social
                    : data.item.nome_completo
                }}
              </strong>
            </template>

            <template v-slot:cell(participacoes_confirmadas)="data">
              <strong>{{ data.value || 0 }}</strong>
            </template>

            <template v-slot:cell(participacoes_nao_confirmadas)="data">
              <strong>{{ data.value || 0 }}</strong>
            </template>
            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                  :alt="$t('No results')"
                  class="mb-5"
                  src="/img/icons/robot.svg"
                  style="max-height: 165px"
                />
                <h3 class="bold">
                  {{ $t("No records found") }}
                </h3>
              </div>
            </template>
          </b-table>

          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
              <div class="form-group d-inline-flex mb-0">
                <select
                  class="form-control"
                  style="width: 70px"
                  v-model="perPage"
                  v-on:change="getItens"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </div>
              <div class="d-inline-flex ml-2">
                <b-pagination
                  :per-page="perPage"
                  :total-rows="pagination.total"
                  @change="changePage"
                  v-model="page"
                />
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
              <div class="float-lg-right">
                {{ $t("Showing page") }}
                {{ pagination.currentPage }}
                {{ $t("of") }}
                {{ pagination.totalPages }}
                {{ $t("pages in") }}
                {{ pagination.total }}
                {{ $t("records") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "UsuariosParticipacoesAtividades",
  metaInfo() {
    return {
      title: this.$i18n.t("Registro de participações em atividades do SCFV"),
    };
  },
  data() {
    return {
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      itemList: [],
      participantes: [],
      filtro: null,
      user_id: null,
    };
  },
  mounted() {
    this.getItens();
  },

  methods: {
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getItens();
      }
    },
    getItens() {
      this.loading = true;
      axios
        .get(
          "api/dashboard/scfv/usuarios/participacoes/" + this.$route.params.id,
          {
            params: {
              page: this.page,
              search: this.search,
              perPage: this.perPage,
            },
          }
        )
        .then((response) => {
          this.itemList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getItens();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
